import {
    FETCH_BODY_BATTERY_REPORT_FETCHING,
    FETCH_BODY_BATTERY_REPORT_SUCCESS,
    FETCH_BODY_BATTERY_REPORT_FAIL,
    FETCH_BODY_BATTERY_EVENTS_FETCHING,
    FETCH_BODY_BATTERY_EVENTS_SUCCESS,
    FETCH_BODY_BATTERY_EVENTS_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    dailyBodyBatteryReportData: null,
    isDailyBodyBatteryReportFetching: false,
    didDailyBodyBatteryReportFail: false,
    dailyBodyBatteryEvents: [],
    isDailyBodyBatteryEventsFetching: false,
    didDailyBodyBatteryEventsFail: false
};

// ======= Fetching Handlers =======

//reports data
const fetchDailyBodyBatteryReportFetching = (state) => {
    return {
        ...state,
        isDailyBodyBatteryReportFetching: true,
        didDailyBodyBatteryReportFail: false
    };
};

const fetchDailyBodyBatteryReportSuccess = (state, action) => {
    return {
        ...state,
        dailyBodyBatteryReportData: action.data,
        isDailyBodyBatteryReportFetching: false,
        didDailyBodyBatteryReportFail: false
    };
};

const fetchDailyBodyBatteryReportFail = (state, action) => {
    delete state.bodyBattery.dailyBodyBatteryReportData;
    return {
        ...state,
        dailyBodyBatteryReportData: null,
        isDailyBodyBatteryReportFetching: false,
        didDailyBodyBatteryReportFail: true
    };
};

//one day view data
const fetchDailyBodyBatteryEventsFetching = (state) => {
    return {
        ...state,
        isDailyBodyBatteryEventsFetching: true,
        didDailyBodyBatteryEventsFail: false
    };
};

const fetchDailyBodyBatteryEventsSuccess = (state, action) => {
    return {
        ...state,
        dailyBodyBatteryEvents: action.data,
        isDailyBodyBatteryEventsFetching: false,
        didDailyBodyBatteryEventsFail: false
    };
};

const fetchDailyBodyBatteryEventsFail = (state, action) => {
    delete state.dailyBodyBatteryEvents;
    return {
        ...state,
        dailyBodyBatteryEvents: null,
        isDailyBodyBatteryEventsFetching: false,
        didDailyBodyBatteryEventsFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_BODY_BATTERY_REPORT_FETCHING]: fetchDailyBodyBatteryReportFetching,
    [FETCH_BODY_BATTERY_REPORT_SUCCESS]: fetchDailyBodyBatteryReportSuccess,
    [FETCH_BODY_BATTERY_REPORT_FAIL]: fetchDailyBodyBatteryReportFail,
    [FETCH_BODY_BATTERY_EVENTS_FETCHING]: fetchDailyBodyBatteryEventsFetching,
    [FETCH_BODY_BATTERY_EVENTS_SUCCESS]: fetchDailyBodyBatteryEventsSuccess,
    [FETCH_BODY_BATTERY_EVENTS_FAIL]: fetchDailyBodyBatteryEventsFail
};

// ======= Default Action =======
export default function bodyBattery(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getDailyBodyBatteryReportData = (state, date) => {
    return state.bodyBattery.dailyBodyBatteryReportData;
};

export const isDailyBodyBatteryReportDataFetching = (state) => {
    return state.bodyBattery.isDailyBodyBatteryReportFetching;
};

export const didDailyBodyBatteryReportFetchFail = (state) => {
    return state.bodyBattery.didDailyBodyBatteryReportFail;
};

export const getDailyBodyBatteryEvents = (state) => {
    return state.bodyBattery.dailyBodyBatteryEvents;
};

export const isDailyBodyBatteryEventsFetching = (state) => {
    return state.bodyBattery.isDailyBodyBatteryEventsFetching;
};

export const didDailyBodyBatteryEventsFetchFail = (state) => {
    return state.bodyBattery.didDailyBodyBatteryEventsFail;
};
